import React from 'react';
import { useForm } from "react-hook-form";

export const ManageGroupFrom = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = (data) => {
        let addData = {
            groupName: data.groupName,
            creationDate: today,
            groupDescription: data.groupDes,
        }
        console.log(addData);
    }
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    <div className="co-lg-6 col-md-6">
                        <h6>Group Name</h6>
                        <input className="form-control " placeholder="Group Name"     {...register("groupName", { required: true })} />
                        <small className="mb-2 text-muted">Group Name, Used for oraganization</small> <br />
                        {errors.groupName && <span className="text-danger">This field is required</span>}
                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6 >Creation Date</h6>
                        <input className="form-control " disabled value={today} {...register("creationDate")} />
                        <small className="mb-2 text-muted">The Group was created on the following date</small>

                    </div>
                    <div className="co-lg-12 col-md-12 mt-3">
                        <h6 >Group Description</h6>
                        <input className="form-control  " placeholder="Group Description"  {...register("groupDes", { required: true })} />
                        <small className="mb-2 text-muted">Description of the group</small> <br />
                        {errors.groupDes && <span className="text-danger">This field is required</span>}
                    </div>
                </div>
                <div className="dataTableSubmitBtn">
                    <input className="btn btn-success" value="Submit" type="submit" />
                </div>
            </form>

        </>

    );
};
export const ManageGroupEditDetails = ({ userDetails }) => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) => {
        let EditData = {
            groupName: data.groupName,
            creationDate: today,
            groupDescription: data.groupDes,
        }
        console.log(EditData);
    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    <div className="co-lg-6 col-md-6">
                        <h6>Group Name</h6>
                        <input className="form-control " placeholder="Group Name" defaultValue={userDetails.name}    {...register("groupName", { required: true })} />
                        <small className="mb-2 text-muted">Group Name, Used for oraganization</small> <br />
                        {errors.groupName && <span className="text-danger">This field is required</span>}
                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6 >Creation Date</h6>
                        <input className="form-control " disabled defaultValue={today} {...register("creationDate")} />
                        <small className="mb-2 text-muted">The Group was created on the following date</small>

                    </div>
                    <div className="co-lg-12 col-md-12 mt-3">
                        <h6 >Group Description</h6>
                        <input className="form-control  " placeholder="Group Description" defaultValue={userDetails.description} {...register("groupDes", { required: true })} />
                        <small className="mb-2 text-muted">Description of the group</small> <br />
                        {errors.groupDes && <span className="text-danger">This field is required</span>}
                    </div>
                </div>
                <div className="dataTableSubmitBtn">
                    <input className="btn btn-success" value="Submit" type="submit" />
                </div>
            </form>

        </>
    )
}
